export default __webpack_public_path__ + "static/media/va.aab64b54.jpeg";